module.exports = __webpack_public_path__ + "files/7f39c87d3e823593bf5d726649b95d63.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/lato-bold-webfont.svg
 ** module id = 920
 ** module chunks = 0
 **/